(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('PacketRuleListController', PacketRuleListController);

    PacketRuleListController.$inject = ['$scope', '$stateParams', '$rootScope', '$filter', '$sce', '$translate', '$timeout', 'Authenticate', 'PacketRuleService'];

    function PacketRuleListController($scope, $stateParams, $rootScope, $filter, $sce, $translate, $timeout, Authenticate, PacketRuleService) {
        var vm = this;

        if (!Authenticate.hasPermission('packetRuleList')) {
            return;
        }

        // Variables
        vm.packetRuleList = [];
        vm.requestRunning = false;
        vm.view = {};
        vm.view.tooltip = '';
        vm.typeList = null;
        var hasError = false;
        var searchParams = null;

        // Methods Api
        vm.addPacketRule = addPacketRule;
        vm.editPacketRule = editPacketRule;
        vm.deletePacketRule = deletePacketRule;

        // Methods handle
        vm.toggle = toggle;
        vm.isListEmpty = isListEmpty;
        vm.hasErrorList = hasErrorList;


        // Action Functions
        function addPacketRule() {
            PacketRuleService.addPacketRuleModalConstructor($scope);
        }

        function editPacketRule(packetRuleItem) {
            PacketRuleService.editPacketRuleModalConstructor(packetRuleItem.id, $scope);
        }

        function deletePacketRule(packetRuleItem) {
            var dataAction = {
                action: 'delete',
                methodService: 'deletePacketRule',
                methodExtra: function (packetRuleItem) {
                    vm.packetRuleList.forEach(function (item, index, array) {
                        if (item.id === packetRuleItem[0].id) {
                            array.splice(index, 1);
                        }
                    });
                }
            };
            PacketRuleService.confirmationModalConstructor([packetRuleItem], dataAction);
        }

        function getTooltip() {
            translateTooltip()
            var translateChangeListener = $rootScope.$on('$translateChangeSuccess', translateTooltip);
            $rootScope.$on('$destroy', translateChangeListener);
        }

        function translateTooltip() {
            $translate('tooltip.addPacketRule').then(function (translation) {
                vm.view.tooltip = $sce.trustAsHtml(translation);
            });
        }

        function getPacketRuleList(data) {
            vm.packetRuleList = [];
            vm.requestRunning = true;
            PacketRuleService.listPacketRule(data).then(successListPacketRule).catch(errorListPacketRule);

        }

        function toggle(id) {
            vm.packetRuleList.forEach(function (item) {
                if (item.id == id) {
                    item.opened = !item.opened;
                } else {
                    item.opened = false;
                }
            });
        }

        function isListEmpty() {
            return !vm.requestRunning && !vm.packetRuleList.length && !hasError;
        }

        function hasErrorList() {
            return !vm.requestRunning && !vm.packetRuleList.length && hasError;
        }

        function listenerUpdate() {
            var packetRuleUpdateSuccess = $rootScope.$on('packetRuleUpdateSuccess', function (event, data) {
                vm.packetRuleList.forEach(function (packetRule, index, arrayList) {
                    if (packetRule.id == data.id) {
                        arrayList[index] = parsePacketRule(angular.copy(data));
                        arrayList[index].opened = true;
                    }
                });
            })
            $rootScope.$on('$destroy', packetRuleUpdateSuccess);
        }

        function listenerAdd() {
            var packetRuleAddSuccess = $rootScope.$on('packetRuleAddSuccess', function (event, data) {
                var packetRuleItem = parsePacketRule(angular.copy(data));
                vm.packetRuleList.push(packetRuleItem);
            })
            $rootScope.$on('$destroy', packetRuleAddSuccess);
        }

        // Request Callbacks
        function successListPacketRule(data) {
            vm.requestRunning = false;
            vm.packetRuleList = data.map(parsePacketRule);
            hasError = false;
        }

        function errorListPacketRule() {
            vm.requestRunning = false;
            hasError = true;
        }

        function parsePacketRule(item) {
            if (item.type) {
                item.type = $filter('filter')(vm.typeList, {value: item.type}, true)[0];
            }
            return item;
        }

        function initialize() {
            getTypeList();
            if (!$stateParams.id) {
                getPacketRuleList(searchParams);
            }
            getTooltip();
            listenerUpdate();
            listenerAdd();
        }

        function getTypeList() {
            PacketRuleService.getTypeList().then(function (data) {
                vm.typeList = data;
            });
        }

        $scope.$on('eventFilter', function (event, data) {
            searchParams = data;
            getPacketRuleList(searchParams);
        });

        initialize();

    }
})();